import React from "react";
import { Box, Stack, StackDivider, Tooltip } from "@chakra-ui/react";
import { getWidgetResize, RndWrapper, valueFromString, } from "@govisupro/controls";
import { FiLock, FiTrash } from "react-icons/fi";
import { duplicateItemCoordinates, widgetsWithAnimations } from "../helpers";
import { BiDuplicate } from "react-icons/bi";
import { MdAnimation } from "react-icons/md";
import { useServices } from "../hooks/useServices";
export const LayoutItem = ({ layoutItemsLength, isSelected, children, layoutItem, screenWidth, screenHeight, scale, isLocked, widgets, setAnimationsModalOpened, showAnimations, }) => {
    const { layoutService } = useServices();
    const widget = widgets.find((widget) => widget.name === layoutItem.widgetName);
    const widgetResize = getWidgetResize({
        isSelected,
        isLocked,
        resize: widget === null || widget === void 0 ? void 0 : widget.resize,
    });
    const RndWrapperContent = (React.createElement(React.Fragment, null,
        children,
        isLocked && isSelected ? (React.createElement(Box, { position: "absolute", bottom: "0", right: "0", transform: "translate(50%, 50%)", bgColor: "white", width: "fit-content", p: `${4 / scale}px`, borderRadius: "50%", borderWidth: `${2 / scale}px`, borderColor: "gray.500" },
            React.createElement(FiLock, { size: `${8 / scale}px` }))) : (React.createElement(React.Fragment, null)),
        isSelected && !showAnimations ? (React.createElement(Stack, { direction: "row", spacing: 4, p: `${6 / scale}px`, backgroundColor: "white", position: "absolute", left: "50%", transform: "translateX(-50%)", borderRadius: `${8 / scale}px`, zIndex: 10, className: "rnd-cancel", cursor: "initial", top: valueFromString(layoutItem.y, screenHeight) +
                // @ts-ignore
                (valueFromString(layoutItem.y, screenHeight) === "auto"
                    ? valueFromString(layoutItem.height, screenHeight) / 2
                    : screenHeight * 0.2) <=
                screenHeight / 2
                ? undefined
                : `-${60 / scale}px`, bottom: valueFromString(layoutItem.y, screenHeight) +
                // @ts-ignore
                (valueFromString(layoutItem.y, screenHeight) === "auto"
                    ? valueFromString(layoutItem.height, screenHeight) / 2
                    : screenHeight * 0.2) >
                screenHeight / 2
                ? undefined
                : `-${60 / scale}px`, sx: {
                div: {
                    borderRadius: `${4 / scale}px`,
                    cursor: "pointer",
                    ":hover": {
                        backgroundColor: "gray.100",
                    },
                },
            } },
            React.createElement(Tooltip, { label: "Dupliquer" },
                React.createElement(Box, { "data-testid": "layout-item-duplicate-button", p: `${4 / scale}px`, onClick: (e) => {
                        if (isLocked)
                            return;
                        const newItemId = Math.random().toString(36);
                        layoutService.addLayoutItem({
                            ...layoutItem,
                            id: newItemId,
                            ...duplicateItemCoordinates({
                                x: layoutItem.x,
                                y: layoutItem.y,
                            }),
                            z: layoutItemsLength,
                        });
                    } },
                    React.createElement(BiDuplicate, { size: `${20 / scale}px` }))),
            widget &&
                widgetsWithAnimations.includes(widget.type.toLowerCase()) ? (React.createElement(Tooltip, { label: "Animations" },
                React.createElement(Box, { "data-testid": "layout-item-animations-button", p: `${4 / scale}px`, onClick: () => {
                        if (isLocked)
                            return;
                        setAnimationsModalOpened(true);
                    } },
                    React.createElement(MdAnimation, { size: `${20 / scale}px` })))) : (React.createElement(React.Fragment, null)),
            React.createElement(StackDivider, { borderWidth: 2, cursor: "initial" }),
            React.createElement(Tooltip, { label: "Supprimer" },
                React.createElement(Box, { "data-testid": "layout-item-delete-button", p: `${4 / scale}px`, onClick: () => {
                        if (isLocked)
                            return;
                        layoutService.removeLayoutItem(layoutItem);
                    } },
                    React.createElement(FiTrash, { size: `${20 / scale}px` }))))) : (React.createElement(React.Fragment, null))));
    return !widget || !widget.definesRnd ? (React.createElement(RndWrapper, { isLocked: isLocked, isSelected: isSelected, layoutItem: layoutItem, scale: scale, screenHeight: screenHeight, screenWidth: screenWidth, setSelectedLayoutItem: layoutService.selectLayoutItem, showAnimations: showAnimations, updateLayoutItem: layoutService.updateLayoutItem, widgetResize: widgetResize }, RndWrapperContent)) : (RndWrapperContent);
};
